var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 48,
    viewBox: "0 0 164 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.957 47.1976H6.8908C3.56885 47.1976 0.848145 44.5412 0.848145 41.2979V5.89967C0.848145 2.65631 3.56885 -2.68277e-05 6.8908 -2.68277e-05H157.957C161.279 -2.68277e-05 164 2.65631 164 5.89967V41.2979C164 44.5412 161.279 47.1976 157.957 47.1976Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.957 0.945397C160.755 0.945397 163.032 3.16811 163.032 5.89967V41.2979C163.032 44.0294 160.755 46.2521 157.957 46.2521H6.8908C4.09305 46.2521 1.81648 44.0294 1.81648 41.2979V5.89967C1.81648 3.16811 4.09305 0.945397 6.8908 0.945397H157.957ZM157.957 -2.68277e-05H6.8908C3.56885 -2.68277e-05 0.848145 2.65631 0.848145 5.89967V41.2979C0.848145 44.5412 3.56885 47.1976 6.8908 47.1976H157.957C161.279 47.1976 164 44.5412 164 41.2979V5.89967C164 2.65631 161.279 -2.68277e-05 157.957 -2.68277e-05Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1544 12.0869C58.1544 13.0722 57.8523 13.8613 57.2571 14.4498C56.5728 15.1474 55.6815 15.4984 54.5893 15.4984C53.5454 15.4984 52.6541 15.1415 51.923 14.438C51.1903 13.7241 50.8247 12.848 50.8247 11.7993C50.8247 10.7507 51.1903 9.87456 51.923 9.16659C52.6541 8.45715 53.5454 8.10022 54.5893 8.10022C55.109 8.10022 55.6044 8.20494 56.0773 8.39963C56.5486 8.59579 56.9323 8.86128 57.2103 9.18871L56.5788 9.81113C56.0939 9.25214 55.4337 8.97633 54.5893 8.97633C53.8279 8.97633 53.1677 9.23591 52.6073 9.75951C52.0529 10.2846 51.7749 10.9645 51.7749 11.7993C51.7749 12.6341 52.0529 13.32 52.6073 13.8451C53.1677 14.3628 53.8279 14.6282 54.5893 14.6282C55.3975 14.6282 56.0773 14.3628 56.6136 13.8392C56.9671 13.4925 57.168 13.0147 57.2209 12.4041H54.5893V11.5515H58.1001C58.1424 11.7359 58.1544 11.9144 58.1544 12.0869Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7241 9.13118H60.4263V11.3731H63.3993V12.2256H60.4263V14.4675H63.7241V15.3362H59.4927V8.26245H63.7241V9.13118Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6536 15.3363H66.72V9.13124H64.6973V8.26251H69.6779V9.13124H67.6536V15.3363Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2827 15.3363V8.26251H74.2148V15.3363H73.2827Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3475 15.3362H77.4214V9.13118H75.3911V8.26245H80.3778V9.13118H78.3475V15.3362Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8045 14.4262C89.09 15.1415 88.2047 15.4984 87.1488 15.4984C86.0868 15.4984 85.2015 15.1415 84.487 14.4262C83.774 13.7123 83.4189 12.8362 83.4189 11.7993C83.4189 10.7625 83.774 9.88635 84.487 9.17249C85.2015 8.45715 86.0868 8.10022 87.1488 8.10022C88.1987 8.10022 89.0839 8.45715 89.7985 9.17839C90.5176 9.89815 90.8726 10.7684 90.8726 11.7993C90.8726 12.8362 90.5176 13.7123 89.8045 14.4262ZM85.1774 13.8333C85.7152 14.3628 86.3693 14.6282 87.1488 14.6282C87.9222 14.6282 88.5824 14.3628 89.1142 13.8333C89.6504 13.3038 89.9224 12.6238 89.9224 11.7993C89.9224 10.9748 89.6504 10.2949 89.1142 9.76541C88.5824 9.23591 87.9222 8.97043 87.1488 8.97043C86.3693 8.97043 85.7152 9.23591 85.1774 9.76541C84.6411 10.2949 84.3692 10.9748 84.3692 11.7993C84.3692 12.6238 84.6411 13.3038 85.1774 13.8333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1831 15.3363V8.26251H93.3161L96.839 13.764H96.8798L96.839 12.4041V8.26251H97.7711V15.3363H96.7982L93.1091 9.5634H93.0684L93.1091 10.9292V15.3363H92.1831Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.191 25.6667C80.3524 25.6667 78.0336 27.7758 78.0336 30.6858C78.0336 33.5723 80.3524 35.7035 83.191 35.7035C86.0355 35.7035 88.3544 33.5723 88.3544 30.6858C88.3544 27.7758 86.0355 25.6667 83.191 25.6667ZM83.191 33.7271C81.6335 33.7271 80.2935 32.472 80.2935 30.6858C80.2935 28.8761 81.6335 27.6431 83.191 27.6431C84.7485 27.6431 86.0945 28.8761 86.0945 30.6858C86.0945 32.472 84.7485 33.7271 83.191 33.7271ZM71.938 25.6667C69.0934 25.6667 66.7806 27.7758 66.7806 30.6858C66.7806 33.5723 69.0934 35.7035 71.938 35.7035C74.7811 35.7035 77.0954 33.5723 77.0954 30.6858C77.0954 27.7758 74.7811 25.6667 71.938 25.6667ZM71.938 33.7271C70.379 33.7271 69.0345 32.472 69.0345 30.6858C69.0345 28.8761 70.379 27.6431 71.938 27.6431C73.4955 27.6431 74.8355 28.8761 74.8355 30.6858C74.8355 32.472 73.4955 33.7271 71.938 33.7271ZM58.5475 27.205V29.3377H63.7638C63.6112 30.5295 63.2034 31.4056 62.5779 32.0162C61.8166 32.7537 60.6307 33.5722 58.5475 33.5722C55.3373 33.5722 52.8236 31.0428 52.8236 27.9085C52.8236 24.7743 55.3373 22.2448 58.5475 22.2448C60.2832 22.2448 61.5462 22.9071 62.4782 23.7655L64.0176 22.2625C62.7139 21.0472 60.9797 20.1136 58.5475 20.1136C54.1454 20.1136 50.4458 23.6106 50.4458 27.9085C50.4458 32.2065 54.1454 35.7035 58.5475 35.7035C60.9268 35.7035 62.7139 34.9425 64.1188 33.5147C65.5585 32.1091 66.0072 30.1327 66.0072 28.5369C66.0072 28.0413 65.9649 27.5855 65.8893 27.205H58.5475ZM113.303 28.8584C112.879 27.736 111.569 25.6667 108.901 25.6667C106.257 25.6667 104.056 27.7006 104.056 30.6858C104.056 33.497 106.235 35.7035 109.155 35.7035C111.516 35.7035 112.879 34.2979 113.439 33.4793L111.687 32.3392C111.102 33.174 110.306 33.7271 109.155 33.7271C108.011 33.7271 107.191 33.2153 106.665 32.2065L113.54 29.4292L113.303 28.8584ZM106.294 30.5295C106.235 28.5944 107.833 27.6032 108.978 27.6032C109.875 27.6032 110.637 28.0413 110.89 28.6681L106.294 30.5295ZM100.706 35.3982H102.966V20.649H100.706V35.3982ZM97.0045 26.7846H96.9289C96.4214 26.1976 95.453 25.6667 94.2264 25.6667C91.6522 25.6667 89.2986 27.8731 89.2986 30.702C89.2986 33.5147 91.6522 35.7035 94.2264 35.7035C95.453 35.7035 96.4214 35.1681 96.9289 34.5634H97.0045V35.2832C97.0045 37.202 95.9546 38.233 94.2611 38.233C92.8804 38.233 92.0238 37.2596 91.6703 36.441L89.7049 37.2419C90.2714 38.5722 91.7715 40.2094 94.2611 40.2094C96.9108 40.2094 99.1466 38.6873 99.1466 34.9838V25.972H97.0045V26.7846ZM94.4197 33.7271C92.8622 33.7271 91.5585 32.4543 91.5585 30.702C91.5585 28.9336 92.8622 27.6431 94.4197 27.6431C95.9546 27.6431 97.1646 28.9336 97.1646 30.702C97.1646 32.4543 95.9546 33.7271 94.4197 33.7271ZM123.884 20.649H118.479V35.3982H120.732V29.8097H123.884C126.387 29.8097 128.842 28.0413 128.842 25.2286C128.842 22.4174 126.381 20.649 123.884 20.649ZM123.943 27.7581H120.732V22.7006H123.943C125.626 22.7006 126.586 24.0649 126.586 25.2286C126.586 26.3702 125.626 27.7581 123.943 27.7581ZM137.875 25.6386C136.247 25.6386 134.554 26.3407 133.857 27.8967L135.857 28.7153C136.288 27.8967 137.079 27.6313 137.916 27.6313C139.086 27.6313 140.271 28.3171 140.29 29.528V29.6829C139.882 29.4528 139.008 29.1121 137.934 29.1121C135.78 29.1121 133.585 30.2699 133.585 32.4307C133.585 34.4071 135.35 35.6799 137.333 35.6799C138.85 35.6799 139.687 35.0118 140.212 34.2345H140.29V35.3746H142.466V29.7168C142.466 27.1018 140.466 25.6386 137.875 25.6386ZM137.604 33.7212C136.866 33.7212 135.839 33.3643 135.839 32.472C135.839 31.3304 137.12 30.8923 138.229 30.8923C139.221 30.8923 139.687 31.1062 140.29 31.3879C140.113 32.7537 138.909 33.7212 137.604 33.7212ZM150.397 25.9616L147.807 32.3554H147.73L145.051 25.9616H142.62L146.645 34.8967L144.349 39.8687H146.704L152.905 25.9616H150.397ZM130.08 35.3982H132.34V20.649H130.08V35.3982Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4604 8.89533C13.1054 9.25816 12.8999 9.82305 12.8999 10.5546V36.649C12.8999 37.3806 13.1054 37.9455 13.4604 38.3083L13.548 38.3879L28.5247 23.7714V23.4263L13.548 8.80978L13.4604 8.89533Z",
    fill: "url(#paint0_linear_903_8843)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5101 28.6459L28.5234 23.7713V23.4262L33.5162 18.5515L33.628 18.615L39.5407 21.8996C41.2281 22.8318 41.2281 24.3657 39.5407 25.3038L33.628 28.5825L33.5101 28.6459Z",
    fill: "url(#paint1_linear_903_8843)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6274 28.5826L28.5228 23.5988L13.4585 38.3082C14.019 38.8835 14.9329 38.9528 15.9722 38.3776L33.6274 28.5826Z",
    fill: "url(#paint2_linear_903_8843)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6274 18.615L15.9722 8.82C14.9329 8.25068 14.019 8.32 13.4585 8.89522L28.5228 23.5988L33.6274 18.615Z",
    fill: "url(#paint3_linear_903_8843)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_903_8843",
    x1: 27.195,
    y1: 36.9207,
    x2: 7.39839,
    y2: 16.6445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_903_8843",
    x1: 41.738,
    y1: 23.5971,
    x2: 12.4953,
    y2: 23.5971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_903_8843",
    x1: 30.8517,
    y1: 20.8895,
    x2: 4.00594,
    y2: -6.6067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_903_8843",
    x1: 9.66649,
    y1: 46.9897,
    x2: 21.6543,
    y2: 34.7115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.f0bee2d750714d1a15854a6db7a1518a.svg";
export { ForwardRef as ReactComponent };